var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArbeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.716 165.184L164.644 220.608L197.835 201.704L150.648 128.606L128.716 165.184Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.058 179.47L228.034 164.324L176.474 85.3958L157.346 117.298L207.119 196.413L225.115 186.165C226.881 184.755 227.949 182.687 228.061 180.456L228.058 179.47Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 193.755L37.414 208.148L121.985 74.8475L107.631 74.4753C95.4021 74.3055 82.2283 77.4302 76.1819 87.1308L28.1571 160.29L12.0004 184.688V193.755Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.795 74.8481L132.967 74.983L47.3832 213.789L77.2973 230.716L85.4323 217.157L170.795 74.8481Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244 74.6564C243.684 66.881 239.4 59.7631 232.69 55.619L138.648 2.46528C132.01 -0.819342 123.72 -0.823466 117.07 2.46315C116.285 2.85284 25.6158 54.5344 25.6158 54.5344C24.361 55.126 23.1523 55.8305 22.0155 56.6303C16.0259 60.8492 12.375 67.4057 12 74.6085L12.0004 184.688L28.1571 160.29L28.0156 75.3525C28.0344 75.0418 28.0742 74.7361 28.1304 74.4344C28.4957 72.4361 29.631 70.6532 31.3403 69.4484C31.7668 69.1483 123.985 16.6852 124.277 16.5413C126.444 15.4715 129.199 15.4588 131.37 16.5082L224.196 68.9859C226.392 70.3606 227.769 72.6912 227.892 75.2391V180.456C227.779 182.687 226.881 184.755 225.117 186.165L164.644 220.608L130.985 239.778C129.172 240.422 127.053 240.385 125.256 239.667L85.4323 217.157L77.2973 230.716L113.085 250.968C114.268 251.63 115.323 252.215 116.188 252.693C117.527 253.431 118.441 253.925 118.763 254.079C121.307 255.293 124.967 256 128.264 256C131.289 256 134.237 255.454 137.026 254.38L234.791 198.734C240.402 194.462 243.702 188.018 244 181.036V74.6564Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbeth);
export default __webpack_public_path__ + "static/media/arbeth.f47d8e85.svg";
export { ForwardRef as ReactComponent };